import React, { Fragment } from "react";
import { Form, Input, Switch, Button, Upload, message } from "antd";
import { ReactSVG } from "react-svg";
import JoditEditor from "jodit-react";

const CategoryForm = ({
	handleSubmitForm,
	convertUploadFile,
	form,
	categoryId,
	handleCancel,
}) => {
	const props = {
		name: "file",
		action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
		headers: {
			authorization: "authorization-text",
		},
		onChange(info) {
			if (info.file.status !== "uploading") {
				convertUploadFile(info.file.originFileObj);
			}
			if (info.file.status === "uploading") {
				message.success(`${info.file.name} file uploaded successfully`);
			} else if (info.file.status === "error") {
				message.error(`${info.file.name} file upload failed.`);
			}
		},
	};

	return (
		<Fragment>
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Name"
						name="name"
						rules={[{ required: true, message: "Required" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						label="Short Name"
						name="short_name"
						rules={[{ required: true, message: "Required" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						label="Description"
						name="description"
						rules={[{ required: true, message: "Required" }]}
					>
						<JoditEditor />
					</Form.Item>
					<Form.Item label="Informative Text" name="informative_text">
						<JoditEditor />
					</Form.Item>
					{/* <Form.Item
						label="See More"
						name="see_more"
						rules={[{ required: true, message: "Required" }]}
					>
						<Select
							mode="multiple"
							style={{ width: "100%" }}
							placeholder="See More"
							optionLabelProp="label"
						>
							{categories &&
								categories.map(
									(category) =>
										categoryId &&
										parseInt(categoryId) !== parseInt(category.id) && (
											<Select.Option
												key={category.id}
												value={`${category.id}|${category.name}`}
												label={category.name}
											>
												{category.name}
											</Select.Option>
										),
								)}
						</Select>
					</Form.Item> */}
					<Form.Item label="Disclaimer" name="disclaimer">
						<Input />
					</Form.Item>
					<Form.Item label="Published" name="published" valuePropName="checked">
						<Switch />
					</Form.Item>
					{!categoryId && (
						<Form.Item label="Image" name="image">
							<Upload {...props}>
								<Button>Click to Upload</Button>
							</Upload>
						</Form.Item>
					)}
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn btn-primary">
						{categoryId ? "Update" : "Create"}
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</Fragment>
	);
};

export default CategoryForm;
